import {authorizationServicesPath, estimateServicesPath, ordersServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = ordersServicesPath + '/admin/unsuitable-organization-error'

export default class AdminErrorsService {

    static async get() {
        return axios.get(restUrl);
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}